import { defineAction } from '~/prix'
import { z } from 'zod'
import { dateOrIsoString } from '~/prix/types/date'
import { reportFormatSchema } from '~/utils/server/report'
import { communityObject } from '~/packages/geo/community/communityObject'
import { heavyMachineryObject } from '../../heavyMachinery/heavyMachineryObject'
import { machineServiceObject, machineServiceStatus } from '../machineServiceObject'
import machineServiceReportAction from './machineServiceReport.action.json' with { type: 'json' }
import { machineServiceReportTypeValues } from './machineServiceReportShared'

const machineServiceReportTypeSchema = z
  .enum(machineServiceReportTypeValues)
  .default('serviceRequests')

const machineServiceReportDefinition = defineAction({
  ...machineServiceReportAction,

  input: z.object({
    format: reportFormatSchema,
    reportType: machineServiceReportTypeSchema,
    citizenId: machineServiceObject.shape.citizenId.nullish(),
    communityId: communityObject.shape.id.nullish(),
    serviceType: machineServiceObject.shape.serviceType.nullish(),
    machineType: heavyMachineryObject.shape.type.nullish(),
    heavyMachineryId: machineServiceObject.shape.heavyMachineryId.nullish(),
    operatorId: machineServiceObject.shape.operatorId.nullish(),
    requestStartDate: dateOrIsoString().nullish(),
    requestEndDate: dateOrIsoString().nullish(),
    startDate: dateOrIsoString().nullish(),
    endDate: dateOrIsoString().nullish(),
    status: machineServiceStatus.nullish(),
  }),
  output: z.any(),
})

export default machineServiceReportDefinition
